/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".subtitle[_ngcontent-%COMP%]{margin-top:.5rem}.subtitle-label[_ngcontent-%COMP%]{color:#aaa}"];
export { styles as styles };

